import Vue from 'vue'
import tools from '@/common/utils/tools'

/**
 * WebIDE
 *
 * 窗口布局管理
 * 模态框管理
 * 配置管理
 *
 */

const WebIde = Vue.extend({
  data () {
    return {
      registered: false,

      device: {
        height: 0,
        width: 0
      },

      inputModal: {
        active: false,
        resolve: null,
        prompt: '',
        stop: null
      },

      setting: {
        token: '',
        userId: null,
        codeFont: 'Monaco, Menlo, "Ubuntu Mono", Consolas, source-code-pro, monospace;',
        fontSize: 16,
        startLearningAt: new Date()
      },

      layoutSetting: {
        showNav: true,
        leftNavWidth: 300,
        topnavHeight: 60,
        commandsHeight: 50,
        leftWidth: 0,
        rightWidth: 0
      },

      playground: {
        active: false,
        code: '',
        attachments: []
      },

      modals: {
        exitGroup: { active: false, noHeader: true, noFooter: true, manualClose: true }
      }
    }
  },
  computed: {
    layout: {
      get () {
        const codeEditorHeight = ~~(this.device.height - this.layoutSetting.topnavHeight - this.layoutSetting.commandsHeight) * 0.6
        return {
          ...this.layoutSetting,
          mainWidth: this.device.width - (this.layoutSetting.showNav ? this.layoutSetting.leftNavWidth : 0),
          mainHeight: this.device.height - this.layoutSetting.topnavHeight,
          codeEditorHeight: codeEditorHeight,
          shellHeight: (this.device.height - this.layoutSetting.topnavHeight - this.layoutSetting.commandsHeight - codeEditorHeight)
        }
      },
      set (obj) {
        Object.keys(obj).forEach(key => {
          this.$set(this.layoutSetting, key, obj[key])
        })
      }
    }
  },
  async created () {
    this.historyCode = ['']
    this.setDevice(tools.getWindowSize())
  },
  beforeDestroy () {
    if (this.registered) {
      window.removeEventListener('resize', this.onResize)
    }
  },
  methods: {
    registerIDE (app) {
      this.$noty = app.$noty
      this.$api = app.$api
      window.addEventListener('resize', this.onResize)
      this.registered = true
    },
    onResize () {
      this.setDevice(tools.getWindowSize())
    },
    setDevice ({ height, width }) {
      this.device.height = height
      this.device.width = width
    },
    getSetting (key) {
      return this.setting[key]
    },
    setSetting (key, value) {
      return this.setting[key] = value
    },
    getLocal (key) {
      localStorage.getItem(key)
      return null
    },
    setLocal (key, value) {
      return localStorage.setItem(key, value)
    },
    async getInput (dialogConfig, delay = 300, stop) {
      await new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, delay)
      })
      return new Promise((resolve) => {
        this.inputModal.stop = stop || null
        this.inputModal.active = true
        this.inputModal.prompt = dialogConfig.prompt
        this.inputModal.resolve = resolve
        this.inputModal.title = dialogConfig.title
        this.inputModal.default = dialogConfig.default
        this.inputModal.min = dialogConfig.min
        this.inputModal.max = dialogConfig.max
        this.inputModal.type = dialogConfig.type || 'string'
      })
    },
    toggleNav (show) {
      if (show === void 0) {
        this.layout = { showNav: !this.layout.showNav }
      } else {
        this.layout = { showNav: show }
      }
    }
  }
})

const IDE = new WebIde()

window['IDE'] = IDE
